// extracted by mini-css-extract-plugin
export default {"project":"Project_project__iVGMp"};